<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.72763 6.96094C1.26188 7.39542 1 7.88515 1 8.40325C1 10.1955 4.13401 11.6484 8 11.6484C11.866 11.6484 15 10.1955 15 8.40325C15 7.88515 14.7381 7.39542 14.2724 6.96094M1.72763 10.7109C1.26188 11.1454 1 11.6352 1 12.1532C1 13.9455 4.13401 15.3984 8 15.3984C11.866 15.3984 15 13.9455 15 12.1532C15 11.6352 14.7381 11.1454 14.2724 10.7109" stroke="currentColor" stroke-width="1.6"/>
    <path d="M15.2 4.61719C15.2 5.33819 14.6314 6.18193 13.2837 6.89266C11.9725 7.58412 10.1058 8.03594 8 8.03594C5.89424 8.03594 4.02752 7.58412 2.71631 6.89266C1.36855 6.18193 0.8 5.33819 0.8 4.61719C0.8 3.89619 1.36855 3.05245 2.71631 2.34172C4.02752 1.65026 5.89424 1.19844 8 1.19844C10.1058 1.19844 11.9725 1.65026 13.2837 2.34172C14.6314 3.05245 15.2 3.89619 15.2 4.61719Z" stroke="currentColor" stroke-width="1.6"/>
  </svg>
</template>

<script setup>
</script>
